import React, { useState } from 'react'

export default function SaveReportSettings({close, save, deleteSetting, use, settings, saving, type}) {
    const [name, setName] = useState('')

    const validateData = () => {
        if (!name || name.length < 1) {
            Alert.show('error', 'Name is a required field')
            return
        }

        save(name)
    }

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <h4>Saved Report Settings</h4>

                {type == 'create' &&
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='form-group'>
                                <label htmlFor='name'>Name</label>
                                <input type='text' step="1" className='form-control' name='name' id='name' placeholder='Settings Name' 
                                    value={name} onChange={(event) => setName(event.target.value)} disabled={saving}
                                />
                            </div>
                        </div>
                    </div>
                }

                {type == 'manage' &&
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='form-group'>
                                {settings && settings.length > 0 && settings.map(setting => (
                                    <div key={setting.id} className='d-flex justify-content-between align-items-center mb-2'>
                                        <p>{setting.name}</p>
                                            <div className='d-flex'>
                                            <button 
                                                className='btn btn-primary btn-sm'
                                                onClick={() => use(setting)}
                                                disabled={saving}
                                            >
                                                Use
                                            </button>

                                            <button
                                                type='button' 
                                                className='btn btn-icon' 
                                                style={{border: 'none'}}
                                            >
                                                <i 
                                                    className='fa fa-trash text-danger'
                                                    style={{fontSize: '1.2rem'}}
                                                    onClick={() => deleteSetting(setting)} 
                                                    disabled={saving}
                                                >
                                                </i>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                }

                <div className="pt-3">
                    {type == 'create' &&
                        <button onClick={validateData} type="button" className="btn btn-primary mr-2" disabled={!name || saving}>
                            {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                            Save
                        </button>
                    }

                    <button onClick={close} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
